module.exports = __webpack_public_path__ + "img/91761.0c6a7ee7.svg";